import {Component, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {ApiService} from '../../shared/services/api.service';
import {DevicesService, LangService, LoaderService, NavigateService} from '@satoris/ngx-satoris';
import {setStoredItem, getStoredItem} from 'src/app/shared/utils/storage';
import {PermissionsService} from '../../shared/services/permissions.service';
import {environment} from 'src/environments/environment';
import {NfcService} from 'src/app/shared/services/nfc.service';

interface ActivationNavigationState {
  renew?: boolean;
}

@Component({
  selector: 'app-activation',
  templateUrl: './activation.component.html',
  styleUrls: ['./activation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivationComponent {
  environment = environment;
  hasNfc = false;
  setCardRenewalMode = false;
  constructor(public nav: NavigateService,
    public api: ApiService,
    public devices: DevicesService,
    private permissions: PermissionsService,
    public nfc: NfcService,
    private loader: LoaderService,
    private lang: LangService,
    private router: Router) {
    const navigationState = this.router.getCurrentNavigation()?.extras?.state as ActivationNavigationState;
    if(navigationState?.renew) {
      this.api.setCardRenewalMode = true;
      this.setCardRenewalMode = true;
      setStoredItem('cardRenewalMode', true);
      console.debug('Card renewal mode activated via navigation state');
    } else {
      const storedRenewalMode = getStoredItem('cardRenewalMode');
      if(storedRenewalMode) {
        if(this.api.userInfo?.nationalNumber) {
          this.api.setCardRenewalMode = true;
          console.debug('Resuming card renewal mode from storage');
        } else {
          console.debug('Ignoring stored cardRenewalMode: nationalNumber not present (fresh activation)');
        }
      }
    }

    if(!this.api.setCardRenewalMode) setStoredItem('welcomeDone', false);

    this.nfc.detectNfc().then((res: boolean) => {
      this.hasNfc = res;
    });
  }

  accountSelfActivation() {
    if(!this.hasNfc) {
      return this.loader.loading(true, {type: 'warn', message: 'device.noNfc'});
    }
    if(this.devices.isDevices('cordova')){
      this.permissions.checkCameraPermission().then(() => {
        const isCameraPermissionGranted = this.permissions.stateOfPermissions.camera.hasPermission;
        if(isCameraPermissionGranted){
          this.nav.to('activation-step-intro');
        } else {
          this.nav.toPerm('activation', 'activation-step-intro', 'CAMERA');
        }
      });
    } else {
      this.nav.toPerm('activation', 'activation-step-intro', 'CAMERA');
    }
  }

  askDisconnect() {
    this.loader.loading(true, {type: 'warn', message: this.lang.transform('ask.signout'), btnLabel: this.lang.transform('confirm')}).then((done) =>{
      if(done) {
        this.api.signOut(true);
      }
    });
  }
}
